export var SelectedSegment;
(function (SelectedSegment) {
    SelectedSegment["ALL"] = "all";
    SelectedSegment["STORE"] = "store";
    SelectedSegment["SELLER"] = "seller";
    SelectedSegment["CAMPAIGN"] = "campaign";
    SelectedSegment["CLUSTER"] = "cluster";
})(SelectedSegment || (SelectedSegment = {}));
